// import React, { useEffect, useReducer, useRef } from "react";
// import moment from "moment";
// import "moment-timezone"; // Import timezone handling
// import styled from "styled-components";

// const Wrapper = styled.div`
//   color: #666;
// `;

// const TimeTracker = ({ createdAt }) => {
//   const [, forceUpdate] = useReducer((x) => x + 1, 0);
//   const intervalRef = useRef();

//   // Refresh value of `createdAt` every ~ 1 minute
//   useEffect(() => {
//     intervalRef.current = setInterval(() => {
//       forceUpdate();
//     }, 1000);

//     return () => {
//       clearInterval(intervalRef.current);
//     };
//   }, []);

//   // Automatically detect the user's time zone
//   const userTimeZone = moment.tz.guess();
//   console.log("userTimeZone", userTimeZone);

//   // Format the time in the user's time zone
//   const formattedTime = moment(createdAt).tz(userTimeZone).fromNow();

//   return (
//     <Wrapper>
//       <span>{formattedTime}</span>
//     </Wrapper>
//   );
// };

// export default TimeTracker;
import React from "react";
import moment from "moment";
import "moment-timezone"; // Import timezone handling
import styled from "styled-components";

const Wrapper = styled.div`
  color: #666;
`;

const TimeTracker = ({ createdAt }) => {
  // Automatically detect the user's time zone
  const userTimeZone = moment.tz.guess();
  const createdAtUTC = moment.utc(createdAt);
  // console.log("userTimeZone", userTimeZone, createdAtUTC);

  // Format the time in the user's time zone
  // console.log(
  //   "date........... before applying timezone............after applying timezone",
  //   moment(createdAtUTC).fromNow(),
  //   moment(createdAtUTC).tz(userTimeZone).fromNow()
  // );
  const formattedTime = moment(createdAtUTC).tz(userTimeZone).fromNow();

  return (
    <Wrapper>
      <span>{formattedTime}</span>
    </Wrapper>
  );
};

export default TimeTracker;
